import { DatePickerField, SelectField, TextField } from '@ff-it/form';
import { Stack } from '@ff-it/ui';
import { RichTextField } from 'components/RichText';
import { ReactElement } from 'react';
import { required } from 'utilities';
import { TaksStatusField } from '../TaskStatusField';
import { userFieldProps } from 'components';
import { EmbeddedUser } from 'modules/core/types';

type TaskFormProps = {
  assigneeOptions: EmbeddedUser[];
};

export function TaskForm({ assigneeOptions }: TaskFormProps): ReactElement {
  return (
    <>
      <TextField name="name" label="Name" placeholder="Task name" required validate={required} />
      <RichTextField name="content" label="Description" placeholder="Task description" />
      <TaksStatusField name="status" label="Status" required validate={required} />
      <Stack direction="horizontal">
        <DatePickerField name="start_date" label="Start date" placeholder="Start date" className="col px-0" />
        <DatePickerField name="due_date" label="Due date" placeholder="Due date" className="col px-0" />
      </Stack>

      <SelectField
        name="assignees"
        label="Assignees"
        help="Participants of this campaign or plan"
        placeholder="Assignees"
        isMulti
        options={assigneeOptions}
        {...userFieldProps}
      />
    </>
  );
}
